import { Form } from "antd";
import { Rule } from "antd/lib/form";
import React, { FunctionComponent } from "react";

import "./FormField.css";

interface FormFieldProps {
  label?: string;
  rules?: Rule[];
  name: string;
  children: React.ReactNode;
  noMargin?: boolean;
  hidden?: boolean;
}

const FormField: FunctionComponent<FormFieldProps> = ({
  label,
  children,
  name,
  noMargin,
  hidden,
}) => {
  return (
    <Form.Item
      name={name}
      style={noMargin ? { marginBottom: 0 } : {}}
      label={<span className="form-field-label">{label}</span>}
      hidden={hidden}>
      {children}
    </Form.Item>
  );
};

export { FormField };
